import _ from 'lodash'
import { isWealthHub } from 'core/service/investment/funds'
import VALUES from 'core/data-model/constants/values'
import { getToggles } from 'quick-quote/feature-toggles'

export const allFieldsNotEmpty = (fields) => fields.every((f) => f !== undefined && f !== '')

export const isESubAction = (action) => !action
export const isInvestment = (category) => category === VALUES.INVESTMENT
export const isRiskOver = (rpulFundAlloc) => {
  const fundRiskies = _.maxBy(rpulFundAlloc, (fund) => fund.riskLevel) || {}
  const riskLevel = fundRiskies.riskLevel
  return riskLevel > VALUES.HIGH_RISK
}

//TODO [B] adjust function name to match with usage (isWealthHubStaffNeeded)
export const isWealthHubStaff = ({ category, rpulFundAlloc, agentType }) =>
  isInvestment(category) && isWealthHub(agentType) && getToggles().ENABLE_IWEALTH_HUB_STUFF

export const _isRequiredWealthHubStaff = (validateFields, action, agentType) => {
  return (
    isESubAction(action) &&
    isWealthHubStaff({
      category: _.get(validateFields, 'category'),
      rpulFundAlloc: _.get(validateFields, 'rpulFundAlloc'),
      agentType,
    })
  )
}
